import { render } from "./TheSidenav.vue?vue&type=template&id=5a4f4f7b&scoped=true"
import script from "./TheSidenav.vue?vue&type=script&lang=js"
export * from "./TheSidenav.vue?vue&type=script&lang=js"

import "./TheSidenav.vue?vue&type=style&index=0&id=5a4f4f7b&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4f4f7b"]])

export default __exports__